import React, { createContext, useContext, useEffect, useState } from "react";
import { _get } from '../services/apiClient';

const RestaurantDetailsContext = createContext(null);

export const RestaurantDetailsProvider = ({ children }) => {
  const [restaurantDetails, setRestaurantDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // const restaurantId =
  //   localStorage.getItem("restaurantId") ||
  //   sessionStorage.getItem("restaurantId");

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const cacheKey = "restaurantDetails";

        // 1️⃣ Load from cache first
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          setRestaurantDetails(JSON.parse(cached));
        }

        // 2️⃣ Fetch latest from backend
        const res = await _get("/settings");
        // console.log("🔥 API /settings RESPONSE:", res.data);

        if (res.data?.success && res.data.restaurant) {
          setRestaurantDetails(res.data.restaurant);
          localStorage.setItem(
            cacheKey,
            JSON.stringify(res.data.restaurant)
          );
        }
      } catch (err) {
        console.error("Failed to load restaurant details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, []);



  return (
    <RestaurantDetailsContext.Provider
      value={{ restaurantDetails, loading }}
    >
      {children}
    </RestaurantDetailsContext.Provider>
  );
};

export const useRestaurantDetails = () =>
  useContext(RestaurantDetailsContext);
